export class QUIObject {
  constructor() {}

  AcceptContent(contentType) {
    return false;
  }

  HandlePaste(theContent) {}

  CopyContent() {
    return null;
  }

  ObjectName() {
    return "QUIObject";
  }
}
